import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { API_LOGIN_UNIVERSAL } from 'constants/api';
import { showToast } from 'store/toast';
import { clearLSUserData, setIsLoggedIn } from 'helpers';
import { storeName } from '../config';
import { ProfileRefreshTokensResponse } from '../interfaces';

export const profileUniversalLogIn = createAsyncThunk<
  ProfileRefreshTokensResponse,
  { username: string; password: string; captchaToken?: string }
>(`${storeName}/devLogin`, async (data, thunkAPI) =>
  api.axios
    .post(API_LOGIN_UNIVERSAL, data)
    .then((res) => {
      setIsLoggedIn(true);
      clearLSUserData(res.data.user.id, thunkAPI.dispatch);

      return res.data;
    })
    .catch((e) => {
      thunkAPI.dispatch(
        showToast({
          severity: 'error',
          message: e.response?.data.message || e.message,
        }),
      );
      return thunkAPI.rejectWithValue(e.response?.data);
    }),
);
